/* 무료보험 프로모션 추가부분 */
import React, { CSSProperties, PropsWithChildren, useState } from 'react'
import classNames from 'classnames/bind'

import Style from './InsurancePromotionTooltip.module.scss'

import IconClose from '@Ui/images/myhouse/IconClose'
import IconTooltipQmark from '@Ui/images/insurancePromotion/IconTooltipQmark.svg'
import IconTooltipImark from '@Ui/images/insurancePromotion/IconTooltipImark.svg'
import IconTooltip from '@Ui/images/myhouse/IconTooltip'

const cx = classNames.bind(Style)

type Props = {
  title?: string
  message?: string
  style?: CSSProperties
  tooltipIcon?: 'q-mark' | 'i-mark' | 'info-mark'
  tooltipStyle?: CSSProperties
}

const InsurancePromotionTooltip = ({ children, title = '', message = '', style, tooltipIcon = 'q-mark', tooltipStyle }: PropsWithChildren<Props>) => {
  const [showTooltip, setShowTooltip] = useState(false)

  return (
    <div className={cx('article')} style={style}>
      <button
        type="button"
        className={cx('button-tooltip')}
        onClick={() => {
          setShowTooltip(true)
        }}
      >
        {tooltipIcon === 'q-mark' && (
          <span className={cx('icon-tooltip')}>
            <IconTooltipQmark />
          </span>
        )}
        {tooltipIcon === 'i-mark' && (
          <span className={cx('icon-tooltip')}>
            <IconTooltipImark />
          </span>
        )}
        {tooltipIcon === 'info-mark' && (
          <span className={cx('icon')}>
            <IconTooltip width="20" height="20" fill="#9da9bf" stroke="#9da9bf" />
          </span>
        )}
        <span className={cx('blind')}>툴팁 보기</span>
      </button>
      {showTooltip && (
        <div className={cx('tooltip')} style={tooltipStyle}>
          {title && <strong className={cx('title')}>{title}</strong>}
          {message && <p className={cx('message')}>{message}</p>}
          {children}
          <button
            type="button"
            className={cx('button-close')}
            onClick={() => {
              setShowTooltip(false)
            }}
          >
            <span className={cx('icon-close')}>
              <IconClose width={20} height={20} fill="#929294" />
            </span>
            <span className={cx('blind')}>툴팁 닫기</span>
          </button>
        </div>
      )}
    </div>
  )
}

export default InsurancePromotionTooltip
